var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: {
        "data-namespace": "minesweeper-controller",
        "data-style-mode": _vm.isMobile ? "mobile" : "pc"
      }
    },
    [
      _c("section", { attrs: { "data-name": "header" } }, [
        _c(
          "div",
          { staticClass: "header-wrapper" },
          [
            _c("div", { staticClass: "remaining-mines" }, [
              _vm._v(_vm._s(("" + _vm.remainingMines).padStart(3, "0")))
            ]),
            _vm._v(" "),
            _c("action-button", { on: { click: _vm.onRefreshClick } }, [
              _c("div", {
                staticClass: "avatar",
                style: { backgroundImage: "url(" + _vm.avatar + ")" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "time" }, [
              _vm._v(_vm._s(("" + _vm.timing).padStart(3, "0")))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("section", { attrs: { "data-name": "minesweeper" } }, [
        _c(
          "div",
          [
            _vm.isMobile
              ? _c(
                  "movable",
                  [
                    _c(
                      "movable-item",
                      [
                        _c("minesweeper", {
                          ref: "minesweeper",
                          staticClass: "minesweeper",
                          attrs: {
                            debug: _vm.debug,
                            width: _vm.width,
                            height: _vm.height,
                            action: _vm.action,
                            "mines-count": _vm.minesCount,
                            "is-mobile": true
                          },
                          on: {
                            mark: _vm.mark,
                            mousedown: _vm.onMousedown,
                            mouseup: _vm.onMouseup,
                            winning: _vm.onWinning,
                            defeat: _vm.onDefeat,
                            start: _vm.onStart
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c("minesweeper", {
                  ref: "minesweeper",
                  staticClass: "minesweeper",
                  attrs: {
                    debug: _vm.debug,
                    width: _vm.width,
                    height: _vm.height,
                    action: _vm.action,
                    "mines-count": _vm.minesCount
                  },
                  on: {
                    mark: _vm.mark,
                    mousedown: _vm.onMousedown,
                    mouseup: _vm.onMouseup,
                    winning: _vm.onWinning,
                    defeat: _vm.onDefeat,
                    start: _vm.onStart
                  }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isMobile
        ? _c("section", { attrs: { "data-name": "tool" } }, [
            _c(
              "div",
              { staticClass: "tool-wrapper" },
              [
                _vm.action === _vm.DIG
                  ? _c("action-button", { on: { click: _vm.onActionClick } }, [
                      _c("div", { staticClass: "action dig" })
                    ])
                  : _c("action-button", { on: { click: _vm.onActionClick } }, [
                      _c("div", { staticClass: "action mark" })
                    ])
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }